export default __webpack_public_path__ + "static/media/item1.f84beade.svg";